export const NavBar = () => (
  <div className="w-full bg-sky-800 text-white text-center p-2 font-bold">
    <a href="/">Collaborative to do list</a>
  </div>
);
